import { ReactNode } from "react";

import { Edit } from "components/icons/generated";
import ButtonIcon from "ds/components/ButtonIcon";
import CardCollapsible from "ds/components/Card/Collapsible";
import Counter from "ds/components/Counter";
import { useToggle } from "hooks/useToggle";
import useTypedContext from "hooks/useTypedContext";

import { ContextCreationWizardStep } from "../constants";
import { ContextFormContext } from "../context";

type NewContextSummaryPanelProps = {
  name: string;
  step: ContextCreationWizardStep;
  children: ReactNode;
  goToStepDisabled?: boolean;
  count?: number;
};

const NewContextSummaryPanel = ({
  name,
  step,
  children,
  count,
  goToStepDisabled,
}: NewContextSummaryPanelProps) => {
  const { setCurrentStep } = useTypedContext(ContextFormContext);
  const [isCollapsed, toggle] = useToggle(false);

  const goToStep = () => {
    setCurrentStep(step);
  };

  return (
    <CardCollapsible
      ariaLevel={2}
      ariaLabel={name}
      title={name}
      isCollapsed={isCollapsed}
      onToggle={toggle}
      titleSuffix={count !== undefined ? <Counter count={count} /> : undefined}
      headerSuffix={
        <ButtonIcon disabled={goToStepDisabled} icon={Edit} onPress={goToStep} variant="ghost">
          Edit step
        </ButtonIcon>
      }
    >
      {children}
    </CardCollapsible>
  );
};

export default NewContextSummaryPanel;
